module.exports = __webpack_public_path__ + "img/no_message.97f95300.png";